import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    private authService = inject(AuthService);
    private router = inject(Router);

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const authCheck = route.data['authCheck'] || route.data['roles'];
        return this.authService.isAuthorize(authCheck).pipe(
            map((activeSession) => {
                if (!activeSession) {
                    // Check if they are already logged in but unauthorized
                    this.authService.isAuthorize().subscribe((isLoggedIn) => {
                        if (isLoggedIn) {
                            this.router.navigate(['/dashboard/unauthorized']);
                        } else {
                            this.router.navigate(['/'], {
                                queryParams: { returnUrl: state.url },
                            });
                        }
                    });
                    return false;
                }
                return true;
            }),
        );
    }
}
